<template>
   <RPBasicCardVue
    :header="header"
    :hrForBorder="false"
   >

    <template v-if="AUTH_TYPES.OTP === authType">
        <el-form
            slot="body"
            class="rp-helpcenter-login-form"
            :model="loginForm"
            :rules="validationRules"
            ref="loginForm"
            @submit.native.prevent
            :hide-required-asterisk="true"
            >
                <el-form-item
                    class="rp-form-item-field"
                    :label="$t('loginScreen.userIdFieldTitle')"
                    prop="userLoginId"
                    :error="isErrorOccuredWhileOTPsending"
                    :class="{'is-phone-input': isItPhoneInput}"
                    >
                    <el-input
                        :disabled="isOTPGoing"
                        v-model="loginForm.userLoginId"
                        :placeholder="$t('loginScreen.userIdFieldPlaceHolder')"
                    >
                        <el-select
                            filterable
                            v-if="isItPhoneInput"
                            v-model="loginForm.phoneCode"
                            slot="prepend"
                            placeholder="Code"
                            class="rp-form-item-field__phone-code"
                            default-first-option
                            >
                            <el-option
                                v-for="(country, index) in COUNTRIES_DATA"
                                :key="country.phoneCode+index"
                                :value="'+'+country.phoneCode">
                                {{ '+'+country.phoneCode }}
                            </el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item class="rp-messenger-home-scrrn-login-button">
                    <RPSecondaryCTA
                        :label="loginFormSubmitBtnLabel"
                        class="small"
                        buttonType="filled"
                        @click="checkAndSendCode('loginForm')"
                        :isLoading="isOTPGoing"
                        :error="showErrorMessage"
                        icon="el-icon-right"
                    />
                </el-form-item>
        </el-form>
    </template>
    <template v-else>
        <el-form
            slot="body"
            class="rp-helpcenter-login-form"
            :model="orderLoginForm"
            :rules="validationRulesForOrderLoginForm"
            ref="orderLoginForm"
            @submit.native.prevent
            :hide-required-asterisk="true"
            >
                <el-form-item
                    class="rp-form-item-field"
                    :label="$t('loginScreen.orderNumberFieldTitle')"
                    prop="orderNumber"
                    :error="isErrorOccuredWhileOTPsending"
                    >
                    <el-input
                        :disabled="isOTPGoing"
                        v-model="orderLoginForm.orderNumber"
                        :placeholder="$t('loginScreen.orderNumberFieldPlaceholder')"
                    >
                    </el-input>
                </el-form-item>

                <el-form-item
                    v-if="authType === AUTH_TYPES.ORDER_NUMBER_AND_EMAIL"
                    class="rp-form-item-field"
                    :label="$t('loginScreen.emailFieldTitle')"
                    prop="email"
                    :error="isErrorOccuredWhileOTPsending"
                    >
                    <el-input
                        :disabled="isOTPGoing"
                        v-model="orderLoginForm.email"
                        :placeholder="$t('loginScreen.emailFieldPlaceholder')"
                    >
                    </el-input>
                </el-form-item>

                <el-form-item
                    v-if="authType === AUTH_TYPES.ORDER_NUMBER_AND_ZIP_CODE"
                    class="rp-form-item-field"
                    :label="$t('loginScreen.zipcodeFieldTitle')"
                    prop="zipcode"
                    :error="isErrorOccuredWhileOTPsending"
                    >
                    <el-input
                        :disabled="isOTPGoing"
                        v-model="orderLoginForm.zipcode"
                        :placeholder="$t('loginScreen.zipcodeFieldPlaceholder')"
                    >
                    </el-input>
                </el-form-item>


                <el-form-item class="rp-messenger-home-scrrn-login-button">
                    <RPSecondaryCTA
                        :label="loginFormSubmitBtnLabel"
                        class="small"
                        @click="tryOrderLogin('orderLoginForm')"
                        :isLoading="isOTPGoing"
                        :error="showErrorMessage"
                        icon="el-icon-right"
                    />
                </el-form-item>
        </el-form>
    </template>
   </RPBasicCardVue>
</template>
<script>
const errorMessages = {
    "We don't find any user with this user id": "userNotFound"
}
import Form from 'element-ui/packages/form';
import FormItem from 'element-ui/packages/form-item';
import {
    EMAIL_REGEX,
    PHONE_REGEX,
    AUTH_TYPES,
} from '../../helper/constants'
import { mapActions, mapGetters } from 'vuex';

import Countries from '../../helper/countries.json'

const getTypeOfInput = ({ inputValue }) => {

    if (EMAIL_REGEX.test(inputValue)) {
        return 'email';
    }

    if (PHONE_REGEX.test(inputValue)) {
        return 'phone';
    }
    return '';
}
const checkEmailOrPhoneValidation = (rule, inputValue, callback) => {
    return inputValue && getTypeOfInput({ inputValue: inputValue.trim() }) ? callback() : callback(new Error('Enter valid email/phone'));
}
export default {
    props: {
        header: {
            type: String,
            default: 'Login to Help Center',
        }
    },

    components: {
        [Form.name] : Form,
        [FormItem.name]: FormItem,
    },

    data() {
        return {
            loginForm: {
                userLoginId: '',
                phoneCode: '+1',
            },
            orderLoginForm: {
                orderNumber: '',
                email: '', 
                zipcode: '',
            },
            validationRules: {
                userLoginId: [
                    { required: true, message: this.$t('errorMessages.enterEmailOrPhone'), trigger: 'blur' },
                    { validator: checkEmailOrPhoneValidation, trigger: ['blur'], message: this.$t('errorMessages.enterValidOrPhone') }
                ],
            },
            validationRulesForOrderLoginForm: {
                orderNumber: [
                    { required: true, message: 'Please enter order number', trigger: 'blur' }
                ]
            },
            COUNTRIES_DATA: Countries.countriesData,
            showErrorMessage: '',
            numberOfTriesForLogginIn: 0,
            AUTH_TYPES,
        }
    },

    computed: {
        ...mapGetters(['errorsInLoginScreen', 'loadersInLoginScreen']),

        isOTPGoing() {
            return this.loadersInLoginScreen('SEND_CODE_FOR_LOGIN');
        },

        isErrorOccuredWhileOTPsending() {
            let errorMessage = this.loginForm.userLoginId ? this.errorsInLoginScreen('SEND_CODE_FOR_LOGIN') : '';
            if(!errorMessages[errorMessage] || this.$t('errorMessages.'+errorMessages[errorMessage]) === 'errorMessages.'+errorMessages[errorMessage]) {
                return errorMessage;
            }

            return this.$t('errorMessages.'+errorMessages[errorMessage]);
        },

        isItPhoneInput() {
            return getTypeOfInput({ inputValue: this.loginForm.userLoginId }) === 'phone'
        },

        loginFormSubmitBtnLabel() {
            return this.showErrorMessage || this.$t(`loginScreen.sendCode`);
        },

        authType() {
            return this.$root.configuration.authType || AUTH_TYPES.OTP;
        }
    },

    mounted() {
        this.setUpForm();
    },

    methods: {
        ...mapActions(['SEND_CODE_FOR_LOGIN', 'TRY_ORDER_LOGIN']),

        async tryOrderLogin(formName) {
            this.$refs[formName].validate(async (valid) => {
                if(!valid) return false;

                const payload = {
                    ...this.orderLoginForm,
                    authType: this.authType,
                }
                if(payload.email) {
                    payload.email = payload.email.trim()
                }

                const { 
                   status,
                   message,
                   encryptedData,
                   userProperties,
                } = await this.TRY_ORDER_LOGIN({ ...payload, appClientId: this.$root.configuration.id });
                
                if(!status){
                    this.showErrorOnButton(message);
                }

                if(status){
                    this.$emit('loginSuccess', { encryptedData, userProperties, orderNumber: this.orderLoginForm.orderNumber })
                    return;
                }

            });
        },

        async checkAndSendCode(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    let loginData = { ...this.loginForm, userIdType: getTypeOfInput({ inputValue: this.loginForm.userLoginId.trim() }) }
                    if(loginData.userLoginId) loginData.userLoginId = loginData.userLoginId.trim()
                    let { status, message, sourcePersonId } = await this.SEND_CODE_FOR_LOGIN({ ...loginData, appClientId: this.$root.configuration.id });

                    if(status){
                        this.$emit('sendCode', { ...loginData, sourcePersonId })
                        return;
                    }
                    this.numberOfTriesForLogginIn+=1;
                    this.showErrorOnButton(message);

                } else {
                    return false;
                }
            });
        },

        showErrorOnButton(message) {
            
            if(!message) {
                return;
            }

            this.showErrorMessage = this.$t('errorMessages.'+errorMessages[message]) === 'errorMessages.'+errorMessages[message] ? message : this.$t('errorMessages.'+errorMessages[message])

            setTimeout(() => {
                this.showErrorMessage = '';
            }, 2500)
        },

        setUpForm(){
            if(this.authType === AUTH_TYPES.ORDER_NUMBER_AND_ZIP_CODE){
                this.validationRulesForOrderLoginForm['zipcode'] = [
                    { required: true, message: 'Please enter shipping zipcode', trigger: 'blur' }
                ]
            }
            if(this.authType === AUTH_TYPES.ORDER_NUMBER_AND_EMAIL){
                this.validationRulesForOrderLoginForm['email'] = [
                    { required: true, message: 'Please enter email', trigger: 'blur' }
                ]
            }
            if(this.$root.configuration.brandData && this.$root.configuration.brandData.phoneCode) {
                this.loginForm.phoneCode = '+'+this.$root.configuration.brandData.phoneCode;
            }
        }
    }
}
</script>
<style lang="scss">
.rp-helpcenter-login-form {
    padding: 20px;
    @include for-size(tablet-landscape-up) {
        padding: 30px 40px;
    }
    @include for-size(desktop-up){
        padding: 30px 60px;
    }
    .rp-messenger-home-scrrn-login-button {
        // padding: 0px 20px 20px;
        // @include for-size(tablet-landscape-up) {
        //     padding: 0px 40px 30px;
        // }
        // @include for-size(desktop-up){
        //     padding: 0px 60px 30px;
        //     font-size: 16px;
        // }
    }
    .rp-form-item-field {
        .el-form-item__content {
            // padding: 20px 20px 0px;
            // @include for-size(tablet-landscape-up) {
            //     padding: 30px 40px 0px;
            // }
            // @include for-size(desktop-up){
            //     padding: 30px 60px 0px;
            // }
        }
        .el-form-item__label,
        .el-input__inner  {
            color: #333333;
        }
        .el-form-item__label {
            line-height: normal;
            text-align: left;
            margin-bottom: 5px;
            // @include for-size(tablet-landscape-up) {
            //     padding: 30px 40px 0px;
            // }
            @include for-size(desktop-up){
                // padding: 30px 60px 0px;
                font-size: 16px;
            }
        }
        .el-input__inner {
            font-size: 1rem;
            height: 50px;
            line-height: normal;
            @include for-size(tablet-landscape-up) {
                width: 327px;
            }
            @include for-size(desktop-up){
                width: 327px;
            }
            max-width: 100%;
        }
        .el-input__inner:focus {
            border-color: var(--theme-color)
        }
        ::placeholder {
            color: #999999;
        }
        .rp-form-item-field__phone-code {
            width: 100px;
            .el-input__inner {
                max-width: 100px !important;
                min-width: 100px !important;
                &:focus{
                    border: 1px;
                }
            }
        }
    }
    .el-form-item:last-child {
        margin-bottom: 0px;
    }
}

</style>